// extracted by mini-css-extract-plugin
module.exports = {"container":"content_container__29mmN","stats":"content_stats__m27QM","footer":"content_footer__10Fz0"};